// extracted by mini-css-extract-plugin
module.exports = {"categoryWrapper":"Category_categoryWrapper__YCW2r","categoryLink":"Category_categoryLink__26qbN","categoryTitle":"Category_categoryTitle__1kRjr"};